module.exports = __webpack_public_path__ + "static/media/blender.7e4bbbe6.png";